module.exports = __webpack_public_path__ + "img/people9.e570c0b8.png";